module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp--dark-00c68b3702a329da1e2a0210d4df0853.png";